import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of, switchMap, take } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const redirectUnauthorizedToSignIn = (route: ActivatedRouteSnapshot) => {
    const authenticationService = inject(AuthenticationService);
    const router = inject(Router);

    return authenticationService.isLoggedIn().pipe(
        take(1),
        switchMap((authenticated) => {
            if (!authenticated) {
                return of(router.createUrlTree([route.params.tenant, 'sign-in']));
            }
            return of(true);
        }),
    );
};
